ccvalidator.$inject = ['Stripe'];
export default function ccvalidator(Stripe) {
    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {
            scope.testtest = true;
            ctrl.$validators.validCC = function (modelValue, viewValue) {
                // not ideal, but angular doesn't want to update the model
                // if it's not valid, so we just do it anyway here
                if (viewValue === null) {
                    scope.cc.number = null;
                    scope.cc.isValid = false;
                    scope.cc.cardType = 'Unknown';
                    return false;
                }

                const valid = Stripe.card.validateCardNumber(viewValue);
                scope.cc.number = viewValue;
                scope.cc.isValid = valid;
                scope.cc.cardType = Stripe.card.cardType(scope.cc.number);
                return valid;
            };
        },
    };
}
